(function () {
  if (window.__nestMrcFeeFastSync20260707) return;
  window.__nestMrcFeeFastSync20260707 = true;

  var feeVariantId = 39273096544337;
  var feeProductId = 6543483142225;
  var syncTimer = null;
  var syncRunning = false;
  var syncPending = false;
  var retryCount = 0;
  var maxRetryCount = 20;
  var eligibleSignals = ['sparrow', 'owl', 'starling', 'raven', 'puffin'];
  var rawFetch = window.fetch;

  function mark(name, detail) {
    if (window.NestLreCartTiming && typeof window.NestLreCartTiming.mark === 'function') {
      window.NestLreCartTiming.mark(name, detail);
    }
  }

  function currentPath() {
    return window.location && window.location.pathname ? window.location.pathname.toLowerCase() : '';
  }

  function targetPage() {
    var path = currentPath();
    return /\/products\/[^/]*(sparrow|owl|raven|puffin)[^/]*mattress/.test(path) || /\/products\/starling-signature-contour-grid/.test(path);
  }

  function bodyText(body) {
    if (!body) return '';
    if (typeof body === 'string') return body;
    if (body instanceof URLSearchParams) return body.toString();
    if (window.FormData && body instanceof FormData) {
      var parts = [];
      body.forEach(function (value, key) {
        parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      return parts.join('&');
    }
    try {
      return JSON.stringify(body);
    } catch (error) {
      return String(body);
    }
  }

  function isNoteOnlyCartUpdateUrl(url) {
    return typeof url === 'string' && /\/cart\/update(?:\.js)?(?:\?|$)/.test(url) && /[?&]note=/.test(url);
  }

  function isMalformedUndefinedUpdate(url, body) {
    var text = String(url || '') + '&' + bodyText(body);
    return /\/cart\/update(?:\.js)?/i.test(text) && /(updates%5Bundefined%5D|updates\[undefined\]|updates\.undefined)/i.test(text);
  }

  function isTrackedCartMutationUrl(url) {
    if (!targetPage() || typeof url !== 'string' || isNoteOnlyCartUpdateUrl(url)) return false;
    return /\/cart\/(add|change|update)(?:\.js)?(?:\?|$)/.test(url);
  }

  function isCartJsonUrl(url) {
    if (typeof url !== 'string' || /mrc_raw=1/i.test(url)) return false;
    return /\/cart(?:\.js|\/add\.js|\/change\.js|\/update\.js)(?:\?|$)/.test(url);
  }

  function textOf(item) {
    return [
      item && item.product_title,
      item && item.title,
      item && item.handle,
      item && item.url,
      item && item.product_type,
      item && item.vendor
    ].join(' ').toLowerCase();
  }

  function propsOf(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isMrcFee(item) {
    var props = propsOf(item);
    var title = textOf(item);
    return Number(item && item.variant_id) === feeVariantId ||
      Number(item && item.product_id) === feeProductId ||
      String(props.type || '').toLowerCase() === 'fee' ||
      title.indexOf('mrc recycling fee') > -1 ||
      title.indexOf('mattress recycling fee') > -1;
  }

  function isCompanionItem(item) {
    var title = textOf(item);
    return isMrcFee(item) ||
      title.indexOf('lifetime renewal exchange') > -1 ||
      title.indexOf('extend protection') > -1 ||
      title.indexOf('protection plan') > -1;
  }

  function isEligibleMattress(item) {
    if (!item || Number(item.quantity || 0) <= 0 || isCompanionItem(item)) return false;
    var text = textOf(item);
    if (text.indexOf('mattress') > -1) return true;
    return eligibleSignals.some(function (signal) { return text.indexOf(signal) > -1; });
  }

  function eligibleMattressQty(cart) {
    return (cart && cart.items || []).reduce(function (sum, item) {
      return sum + (isEligibleMattress(item) ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  function mrcFeeItems(cart) {
    return (cart && cart.items || []).filter(isMrcFee);
  }

  function mrcFeeQty(cart) {
    return mrcFeeItems(cart).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
  }

  function mrcFeeCents(cart) {
    return mrcFeeItems(cart).reduce(function (sum, item) {
      return sum + Number(item.final_line_price || 0);
    }, 0);
  }

  function formatMoney(cents) {
    return (Number(cents || 0) / 100).toFixed(2);
  }

  function desiredMrcNote(cart) {
    var feeCents = mrcFeeCents(cart);
    if (feeCents <= 0) return '';
    var firstFeeItem = mrcFeeItems(cart)[0] || {};
    var unitCents = Number(firstFeeItem.final_price || firstFeeItem.price || 1800);
    var totalDollars = Math.round(feeCents / 100);
    return 'Recycling Fee: $' + formatMoney(unitCents) + ' | MRC:111110-' + totalDollars + '-CA';
  }

  function transformCartPayload(payload) {
    if (!payload || !Array.isArray(payload.items)) return payload;
    var feeQty = mrcFeeQty(payload);
    var feeCents = mrcFeeCents(payload);
    if (feeQty <= 0 && feeCents <= 0) return payload;

    var clone = Object.assign({}, payload);
    clone.items = payload.items.filter(function (item) { return !isMrcFee(item); });
    if (typeof payload.item_count === 'number') clone.item_count = Math.max(0, payload.item_count - feeQty);
    if (typeof payload.item_count === 'string') clone.item_count = String(Math.max(0, Number(payload.item_count || 0) - feeQty));
    clone.note = desiredMrcNote(payload) || payload.note || '';
    clone.__nest_mrc_fee_quantity = feeQty;
    clone.__nest_mrc_fee_cents = feeCents;
    return clone;
  }

  function updateMrcNote(cart) {
    if (!targetPage() || !rawFetch || !cart) return Promise.resolve(cart);
    var desired = desiredMrcNote(cart);
    if (!desired || String(cart.note || '') === desired) return Promise.resolve(cart);

    mark('MRC fast audit note sync change', { from: cart.note || '', to: desired });
    return rawFetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: 'note=' + encodeURIComponent(desired)
    }).then(function (response) {
      if (!response.ok) throw new Error('MRC fast audit note sync failed: ' + response.status);
      return response.json();
    });
  }

  function changeFeeQuantity(quantity) {
    mark('MRC fast fee quantity sync change', quantity);
    return rawFetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: 'quantity=' + encodeURIComponent(quantity) + '&id=' + encodeURIComponent(feeVariantId)
    }).then(function (response) {
      if (!response.ok) throw new Error('MRC fast fee quantity sync failed: ' + response.status);
      return response.json();
    });
  }

  function syncFeeQuantity(reason) {
    if (!targetPage() || !rawFetch) return;
    if (syncRunning) {
      syncPending = true;
      return;
    }
    syncRunning = true;
    syncPending = false;
    mark('MRC fast fee quantity sync start', reason || 'scheduled');

    rawFetch('/cart.js?mrc_raw=1', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var expected = eligibleMattressQty(cart);
        var current = mrcFeeQty(cart);
        var feeCents = mrcFeeCents(cart);
        mark('MRC fast fee quantity sync state', { expected: expected, current: current, feeCents: feeCents });

        if (expected > 0 && current > 0 && expected !== current) {
          return changeFeeQuantity(expected).then(updateMrcNote);
        }

        return updateMrcNote(cart);
      })
      .catch(function (error) {
        mark('MRC fast fee quantity sync error', error && error.message ? error.message : String(error));
      })
      .then(function () {
        syncRunning = false;
        if (syncPending) scheduleSyncSeries('pending');
      });
  }

  function scheduleSync(reason, delay) {
    if (!targetPage()) return;
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncFeeQuantity(reason);
    }, typeof delay === 'number' ? delay : 750);
  }

  function scheduleSyncSeries(reason) {
    if (!targetPage()) return;
    scheduleSync(reason, 250);
    window.setTimeout(function () { syncFeeQuantity(reason + ' delayed 1'); }, 1200);
    window.setTimeout(function () { syncFeeQuantity(reason + ' delayed 2'); }, 2600);
    window.setTimeout(function () { syncFeeQuantity(reason + ' delayed 3'); }, 4200);
  }

  function cartReadOptions(init) {
    var options = Object.assign({}, init || {});
    options.method = 'GET';
    options.headers = Object.assign({}, options.headers || {}, { 'Accept': 'application/json' });
    delete options.body;
    return options;
  }

  function responseWithCartPayload(response, payload) {
    var headers = new Headers(response.headers || {});
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return new Response(JSON.stringify(transformCartPayload(payload)), {
      status: response.status,
      statusText: response.statusText,
      headers: headers
    });
  }

  function maybeTransformResponse(url, response) {
    if (!isCartJsonUrl(url) || !response || !response.clone) return Promise.resolve(response);
    var contentType = response.headers && response.headers.get ? response.headers.get('content-type') || '' : '';
    if (contentType && contentType.indexOf('json') === -1) return Promise.resolve(response);

    return response.clone().json()
      .then(function (payload) { return responseWithCartPayload(response, payload); })
      .catch(function () { return response; });
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__nestMrcFeeFastSync20260707) return;
    rawFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var init = arguments[1];
      var url = typeof input === 'string' ? input : input && input.url;
      var body = init && init.body;
      var malformed = isMalformedUndefinedUpdate(url, body);
      var tracked = isTrackedCartMutationUrl(url) || malformed;
      var fetchArgs = arguments;

      if (malformed) {
        mark('MRC blocked undefined cart update', url);
        fetchArgs = ['/cart.js?mrc_raw=1', cartReadOptions(init)];
      }

      return rawFetch.apply(this, fetchArgs).then(function (response) {
        if (tracked) scheduleSyncSeries('after fetch ' + url);
        return maybeTransformResponse(String(url || fetchArgs[0] || ''), response);
      }).catch(function (error) {
        if (tracked) scheduleSyncSeries('after fetch error ' + url);
        throw error;
      });
    };
    window.fetch.__nestMrcFeeFastSync20260707 = true;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.__nestMrcFeeFastSync20260707) return;
    var proto = window.XMLHttpRequest.prototype;
    var originalOpen = proto.open;
    var originalSend = proto.send;

    proto.open = function (method, url) {
      var originalUrl = String(url || '');
      var args = Array.prototype.slice.call(arguments);
      if (isMalformedUndefinedUpdate(originalUrl, '')) {
        mark('MRC rewrote undefined cart update', originalUrl);
        args[0] = 'GET';
        args[1] = '/cart.js?mrc_raw=1';
        this.__nestMrcFeeFastSyncMalformed20260707 = originalUrl;
      }
      this.__nestMrcFeeFastSyncUrl20260707 = String(args[1] || '');
      return originalOpen.apply(this, args);
    };

    proto.send = function (body) {
      var xhr = this;
      var url = xhr.__nestMrcFeeFastSyncUrl20260707 || '';
      var malformed = isMalformedUndefinedUpdate(url, body) || !!xhr.__nestMrcFeeFastSyncMalformed20260707;
      var tracked = isTrackedCartMutationUrl(url) || malformed;
      var sendArgs = arguments;

      if (malformed && body) sendArgs = [];
      if (tracked) {
        xhr.addEventListener('loadend', function () {
          scheduleSyncSeries('after xhr ' + (xhr.__nestMrcFeeFastSyncMalformed20260707 || url));
        });
      }
      return originalSend.apply(this, sendArgs);
    };

    proto.__nestMrcFeeFastSync20260707 = true;
  }

  function installInteractionSync() {
    if (window.__nestMrcFeeFastSyncInteractions20260707 || !document || !document.addEventListener) return;
    window.__nestMrcFeeFastSyncInteractions20260707 = true;

    function maybeCartInteraction(event) {
      if (!targetPage()) return;
      var target = event.target;
      if (!target || !target.closest) return;
      var cartScope = target.closest('.cart-modal, .cart-drawer, #CartDrawer, form[action*="/cart"], [data-cart-item], .cart-item');
      if (!cartScope) return;
      if (target.closest('button, a, input, select, [data-quantity-input], [data-cart-remove], [href*="/cart/change"]')) {
        scheduleSyncSeries('after cart interaction');
      }
    }

    document.addEventListener('click', maybeCartInteraction, true);
    document.addEventListener('change', maybeCartInteraction, true);
  }

  function install() {
    patchFetch();
    patchXhr();
    installInteractionSync();
    if (!window.fetch || !window.XMLHttpRequest) {
      retryCount += 1;
      if (retryCount < maxRetryCount) window.setTimeout(install, 100);
    }
    mark('MRC fast fee quantity sync loaded', currentPath());
    scheduleSyncSeries('initial load');
  }

  install();
})();
